/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeContainerStageInput = {
    clientMutationId?: string | null;
    slug: string;
    stage: string;
};
export type ContainersTableStageChangeMutationVariables = {
    input: infoChangeContainerStageInput;
};
export type ContainersTableStageChangeMutationResponse = {
    readonly infoChangeContainerStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainersTableStageChangeMutation = {
    readonly response: ContainersTableStageChangeMutationResponse;
    readonly variables: ContainersTableStageChangeMutationVariables;
};



/*
mutation ContainersTableStageChangeMutation(
  $input: infoChangeContainerStageInput!
) {
  infoChangeContainerStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeContainerStagePayload",
    "kind": "LinkedField",
    "name": "infoChangeContainerStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainersTableStageChangeMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainersTableStageChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b72e988d741000cec36893d0c41ae89e",
    "id": null,
    "metadata": {},
    "name": "ContainersTableStageChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ContainersTableStageChangeMutation(\n  $input: infoChangeContainerStageInput!\n) {\n  infoChangeContainerStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c1a54bf532a1bad469c8231e32b2a725';
export default node;
